if (!customElements.get('almila-blog-posts')) {
class AlmilaBlogPosts extends HTMLElement {
  connectedCallback() {
    this.disconnectedCallback();
    this.track = this.querySelector('.almila-blog-posts__grid');
    this.cards = [...(this.track?.querySelectorAll('.almila-blog-posts__card') || [])];
    this.dots = [...this.querySelectorAll('[data-article-dot]')];
    if (!this.track || this.cards.length < 2 || this.dots.length !== this.cards.length) return;
    this.listeners = new AbortController();
    const signal = this.listeners.signal;
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.showArticle(index), { signal });
      dot.addEventListener('keydown', event => {
        const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        let next = index;
        if (event.key === 'ArrowRight') next += direction;
        else if (event.key === 'ArrowLeft') next -= direction;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.dots.length - 1;
        else return;
        event.preventDefault();
        next = Math.max(0, Math.min(this.dots.length - 1, next));
        this.dots[next].focus();
        this.showArticle(next);
      }, { signal });
    });
    this.track.addEventListener('scroll', () => {
      cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = requestAnimationFrame(() => this.updateCurrentDot());
    }, { signal, passive: true });
    this.resizeObserver = new ResizeObserver(() => this.updateCurrentDot());
    this.resizeObserver.observe(this.track);
    this.setAttribute('data-carousel-ready', '');
    this.updateCurrentDot();
  }

  showArticle(index) {
    const track = this.track.getBoundingClientRect();
    const card = this.cards[index].getBoundingClientRect();
    const rtl = getComputedStyle(this.track).direction === 'rtl';
    this.track.scrollTo({
      left: this.track.scrollLeft + (rtl ? card.right - track.right + 4 : card.left - track.left - 4),
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
  }

  updateCurrentDot() {
    const track = this.track.getBoundingClientRect();
    const rtl = getComputedStyle(this.track).direction === 'rtl';
    let active = 0;
    let distance = Infinity;
    this.cards.forEach((card, index) => {
      const box = card.getBoundingClientRect();
      const current = Math.abs(rtl ? box.right - track.right + 4 : box.left - track.left - 4);
      if (current < distance) {
        active = index;
        distance = current;
      }
    });
    this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === active)));
  }

  disconnectedCallback() {
    cancelAnimationFrame(this.scrollFrame);
    this.listeners?.abort();
    this.resizeObserver?.disconnect();
    this.removeAttribute('data-carousel-ready');
  }
}
  customElements.define('almila-blog-posts', AlmilaBlogPosts);
}
